import "./icon-error.css.ts.vanilla.js";
var a = "_1ao3f5e2", i = "_1ao3f5e1";
export { a as innerAnimation, i as outerAnimation };
